import { Json } from './types';

export const formatForeignNameValue = (
  value: any,
  entities: any,
  fieldMeta: Json,
): string => {
  if (value === null || value === undefined || value === '') return '';

  const items = Object.values(entities || {}) as Json[];
  const valueKey = fieldMeta.value_key || 'name';
  return String(value)
    .split(/[,，]/)
    .map(token => token.trim())
    .filter(token => token.length > 0)
    .map(token => {
      const item = items.find(entity =>
        String(entity[valueKey]) === token ||
        String(entity.uuid) === token ||
        String(entity.name) === token
      );
      return item && item.name ? String(item.name) : token;
    })
    .join(',');
};
